import {
  Key,
  Gear,
  Code,
  CloudArrowUp,
  Envelope,
  Brain,
  SlidersHorizontal,
} from '@phosphor-icons/react';
import type { SubNavConfig } from '../../contexts/SubNavContext';

/**
 * Single source of truth for the Application sub-nav items. Used by both
 * PropertyDetail (/applications/…) and TestDataPropertyDetail
 * (/test-data/applications/…) so the order can't drift between them.
 */
/** Tabs that only make sense for browser apps — hidden for MCP-server applications. */
const BROWSER_ONLY_TAB_IDS = new Set(['inbox', 'code', 'advanced']);

export function buildApplicationSubNavItems(
  base: string,
  isMcp: boolean
): SubNavConfig['items'] {
  const items = [
    { id: 'settings', label: 'General', to: `${base}/settings`, icon: <Gear size={16} /> },
    { id: 'credentials', label: 'Test Users', to: `${base}/credentials`, icon: <Key size={16} /> },
    {
      id: 'environments',
      label: 'Environments',
      to: `${base}/environments`,
      icon: <CloudArrowUp size={16} />,
    },
    { id: 'context', label: 'Skill', to: `${base}/context`, icon: <Brain size={16} /> },
    { id: 'inbox', label: 'Messages', to: `${base}/inbox`, icon: <Envelope size={16} /> },
    { id: 'code', label: 'Code', to: `${base}/code`, icon: <Code size={16} /> },
    {
      id: 'advanced',
      label: 'Advanced',
      to: `${base}/advanced`,
      icon: <SlidersHorizontal size={16} />,
    },
  ];
  return isMcp ? items.filter((item) => !BROWSER_ONLY_TAB_IDS.has(item.id)) : items;
}
